export default "__VITE_ASSET__b91e400c__"